module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2022/polkolonie/big/1-77f9ae16f357c1c27fcae115a51ad3a0.webp";